import React, { useState } from 'react';
import style from '../content-type.module.scss';
import { Pdf as TPdf } from '../../types';
import moment from 'moment';
import { EditIcon, DeleteIcon } from '../../../../icons';
import { AddPdf } from './AddPdf';
import { useMutate, useAppAndBranchId, usePermissions } from '../../../../hooks';
import { api } from '../../api';
import { Modal } from '../../../../components';
import PdfThumbnailIcon from '../../../../../../../../assets/svg/solo-chat/pdf-thumbnail.svg'
import { useToast } from '../../../../../../../../helpers/commonFunction';
import { errorMessage } from '../../../../utils/error';

type Props = {
	pdf: TPdf & { id: string; updatedAt: string|null; createdAt: string };
	refetchContent: () => void;
};

export function Pdf(props: Props) {
	const { ErrorToast } = useToast()
	const [appId, branchId] = useAppAndBranchId();
	const { pdf, refetchContent } = props;
	const { mutate: deleteMutate, loading: deleteLoading } = useMutate(
		api.deleteContent,
	);

	const [modalVisibility, setModalVisibility] = useState({
		editContent: false,
		viewContent: false,
		deleteContent: false,
	});
	

	const [canEdit, canDelete] = usePermissions(['content.Edit', 'content.Delete']) as boolean[]

	function updateVisibility(
		key: keyof typeof modalVisibility,
		visibility: boolean,
	) {
		setModalVisibility((prev) => ({
			...prev,
			[key]: visibility,
		}));
	}

	return (
		<div className={style.contentTypeWrapper}>
			<div data-has-action={canEdit || canDelete} className={style.contentType} onClick={() => {
					updateVisibility('viewContent', true)
				}}>
				<div className={style.media}data-media="pdf"> 
					<div className={style.mediaPreview}>
						<img src={PdfThumbnailIcon} alt="preview" />
					</div>
					<div className={style.mediaInfo}>
						<p>{pdf.contentValue.description}</p>
						<p>{pdf.contentValue.fileName}</p>
					</div>
				</div>
				<div className={style.info}>
					<p>{pdf?.updatedAt ? moment(pdf?.updatedAt).format('DD MMM YYYY, hh:mm A') : "" }</p>
				</div>
				<div className={style.info}>
					<p>{moment(pdf.createdAt).format('DD MMM YYYY, hh:mm A')}</p>
					<div className={style.actions}>
						{(canEdit || canDelete) && <div className={style.line} />}
						{canEdit && <button
							onClick={(e) => {
								e.stopPropagation()
								updateVisibility('editContent', true);
							}}
						>
							<EditIcon width="14" height="14" stroke="#141B34" />
						</button>
						}{ canDelete &&
							<button
								onClick={async (e) => {
									e.stopPropagation()
									updateVisibility('deleteContent', true);
								}}
							>
								<DeleteIcon width="14" height="14" stroke="#D30000" />
							</button>
						}
					</div>
				</div>
			</div>
			{modalVisibility.viewContent && (
				<AddPdf
					mode="view"
					refetchContent={refetchContent}
					initialValue={{
						id: pdf.id,
						fileName: pdf.contentValue.fileName,
						url: pdf.contentValue.url,
						description: pdf.contentValue.description,
					}}
					isOpen={modalVisibility.viewContent}
					close={() => {
						updateVisibility('viewContent', false);
					}}
				/>
			)}
			{modalVisibility.editContent && (
				<AddPdf
					mode="edit"
					refetchContent={refetchContent}
					initialValue={{
						id: pdf.id,
						fileName: pdf.contentValue.fileName,
						url: pdf.contentValue.url,
						description: pdf.contentValue.description,
					}}
					isOpen={modalVisibility.editContent}
					close={() => updateVisibility('editContent', false)}
				/>
			)}
			<Modal
				styles={{
					'--ok-btn-bg': '#DE0000',
					'--ok-btn-filter': 'drop-shadow(0px 8px 13px rgba(211, 0, 73, 0.18))',
				}}
				okText="Delete"
				loading={deleteLoading}
				onOk={async () => {
					try {
						await deleteMutate(appId, branchId, pdf.id);
						refetchContent();
					} catch(err) {
					  ErrorToast(errorMessage("delete", "pdf", err?.code))
					}
				}}
				onCancel={() => updateVisibility('deleteContent', false)}
				isOpen={modalVisibility.deleteContent}
				title="Remove Chosen PDF"
			>
				<div
					style={{
						padding: '18px 14px',
						color: '#393939',
						fontSize: 15,
						fontWeight: 500,
					}}
				>
					<p>Do you really want to remove the chosen PDF?</p>
				</div>
			</Modal>
		</div>
	);
}
